import { doc, getDoc } from "firebase/firestore";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import { db } from "../../../firebase";
import OfferPauseInsurance from "./ChangePeriod";
import isADeviceCheck from "../../../utils/isADeviceCheck";
import ChangePeriod from "./ChangePeriod";

const landingId = "CF_CHANGE_PERIOD";

const onLoad = async ({ session, landedAt, uid }) => {
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;
  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  const lastLanding = landings[landings.length-1]



  const productsToCancel = landings[0];
  const productsField = productsToCancel.answers[0];
  const productType = productsField.type;
  const products = productsField[productType].value;

  const isADevice = isADeviceCheck(products[0].type);

  const userRef = doc(db, "users", uid);
  const docSnapshot = await getDoc(userRef);

  const { firstName } = docSnapshot.data();


  return {
    userId: uid,
    ...prevAnswers,
    landedAt,
    prevForm,
    sessionID: session.sessionID,
    currentLanding: landingId,
    userName: firstName,
    isADevice,
    itComesFrom: lastLanding.id,
    product: products[0]
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(await nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <ChangePeriod state={state} setState={setState} />
);

const nextPage = async (props) =>
  `/formulario/cancelacion/lealtad?uid=${props.uid}`;
const prevPage = (props) => `/formulario/cancelacion/razon?uid=${props.uid}`;

const fieldsStructure = [];

const changePeriodProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default changePeriodProps;
